import yup from '~/utils/validation';

export const passwordRecoveryFormSchema = yup.object().shape({
    email: yup.string().email().required(),
});
